import type { EntityTypeVsAssetClass, Permission } from '../../../consts/permissions';
import type { GlobalAccessControlContextType } from '../GlobalAccessControl';

export type UserEntityPermissions = {
  objects?: { entityType: EntityTypeVsAssetClass; permissions: Permission[] }[];
};

export function getAdaptedPermissions(data: UserEntityPermissions | undefined) {
  if (!data?.objects) return {};

  return data.objects.reduce<GlobalAccessControlContextType>(
    (acc, { entityType, permissions: entityPermissions }) => ({
      ...acc,
      [entityType]: entityPermissions,
    }),
    {},
  );
}
